import React from "react"
import PropTypes from "prop-types"
import Card from "components/sections/sectionInfoCardGrid/card"
import Wrapper from "components/sections/wrapper"
import "./sectionInfoCardGrid.scss"

const SectionInfoCardGrid = ({ cards, contentTitle, layoutStyle }) => {
  return (
    <div className={`info-card-grid info-card-grid--${layoutStyle}`}>
      {contentTitle && (
        <Wrapper {...contentTitle} className="careers-heading-wrapper" />
      )}
      <div className="info-card-grid__cards">
        {cards.map((card, i) => (
          <Card {...card} key={i} layoutStyle={layoutStyle} />
        ))}
      </div>
    </div>
  )
}

SectionInfoCardGrid.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object),
  contentTitle: PropTypes.object,
  layoutStyle: PropTypes.oneOf(["grid", "stacked"]),
}

export default SectionInfoCardGrid
